'use client';
import { handleOpenVideoModal, setCurrentVideo, videoListSelector } from '@lib/store/slices/ComponentsSlice';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import style from './VideoButton.module.scss';

const VideoButton = ({ video, black, white, text = 'смотреть видео о проекте' }) => {
  const dispatch = useDispatch();

  const videoUrlList = useSelector(videoListSelector);

  const currentVideoUrl = videoUrlList[video];

  const buttonStyles = cn(style.button, {
    [style.button_black]: black,
    [style.button_white]: white,
  });

  const handleClick = () => {
    dispatch(setCurrentVideo(currentVideoUrl));
    dispatch(handleOpenVideoModal(true));
  };

  return (
    <button className={buttonStyles} onClick={handleClick}>
      <div>
        <svg viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M11.168 6.85333V25.52L25.8346 16.1867L11.168 6.85333Z' fill='#1C1C1C' />
        </svg>
      </div>
      <span>{text}</span>
    </button>
  );
};

export default VideoButton;
